import React, { SVGProps } from 'react';

const SvgCourierAndDistributionsDrivers = (props: SVGProps<SVGSVGElement>) => (
    <svg width={29.638} viewBox="0 0 29.638 22.568" {...props}>
        <g data-name="Courier and Distributions Drivers">
            <g data-name="Group 150">
                <g data-name="Group 149" fill="#c0694e">
                    <path
                        data-name="Path 512"
                        d="M19.494 16.308h-5.041a.569.569 0 0 1-.569-.569v-5.8a.569.569 0 0 1 .569-.569h5.041a.569.569 0 0 1 .569.569v5.8a.569.569 0 0 1-.569.569Z"
                    />
                    <g data-name="Group 148">
                        <path
                            data-name="Path 513"
                            d="M17.827 12.324v-1.965h-1.708v1.965a.222.222 0 0 0 .222.222h1.263a.222.222 0 0 0 .223-.222Z"
                        />
                        <path
                            data-name="Path 514"
                            d="M17.827 11.339V9.372h-1.708v1.965a.222.222 0 0 0 .222.222h1.263a.222.222 0 0 0 .223-.22Z"
                        />
                    </g>
                    <path
                        data-name="Path 515"
                        d="M20.062 9.943v5.8a.569.569 0 0 1-.569.569h-1.546a.569.569 0 0 0 .569-.569v-5.8a.569.569 0 0 0-.569-.569h1.546a.569.569 0 0 1 .569.569Z"
                    />
                </g>
            </g>
            <g data-name="Group 180">
                <g data-name="Group 175">
                    <g data-name="Group 165" transform="translate(3.301 14.851)">
                        <g data-name="Group 157">
                            <g data-name="Group 151" transform="translate(18.485 .355)">
                                <circle
                                    data-name="Ellipse 46"
                                    cx={3.463}
                                    cy={3.463}
                                    r={3.463}
                                    fill="#685e67"
                                />
                            </g>
                            <g data-name="Group 152">
                                <path
                                    data-name="Path 516"
                                    d="M25.411 3.819a3.464 3.464 0 0 1-4.288 3.363 3.464 3.464 0 0 0 0-6.727 3.464 3.464 0 0 1 4.288 3.364Z"
                                    fill="#554e55"
                                />
                            </g>
                            <g data-name="Group 154">
                                <g
                                    data-name="Group 153"
                                    fill="#12b05e"
                                    transform="translate(20.519 2.389)"
                                >
                                    <circle
                                        data-name="Ellipse 47"
                                        cx={1.43}
                                        cy={1.43}
                                        r={1.43}
                                    />
                                    <path
                                        data-name="Path 517"
                                        d="M2.859 1.429a1.432 1.432 0 0 1-1.43 1.43 1.416 1.416 0 0 1-.563-.116 1.429 1.429 0 0 0 0-2.627A1.417 1.417 0 0 1 1.429 0a1.431 1.431 0 0 1 1.43 1.429Z"
                                    />
                                </g>
                            </g>
                        </g>
                        <circle
                            data-name="Ellipse 48"
                            cx={3.641}
                            cy={3.641}
                            r={3.641}
                            fill="#685e67"
                        />
                        <path
                            data-name="Path 518"
                            d="M7.282 3.641a3.642 3.642 0 0 1-4.508 3.536 3.641 3.641 0 0 0 0-7.072 3.642 3.642 0 0 1 4.508 3.537Z"
                            fill="#554e55"
                        />
                        <g data-name="Group 162">
                            <g data-name="Group 161">
                                <g
                                    data-name="Group 160"
                                    fill="#12b05e"
                                    transform="translate(2.138 2.138)"
                                >
                                    <circle
                                        data-name="Ellipse 49"
                                        cx={1.503}
                                        cy={1.503}
                                        r={1.503}
                                    />
                                    <path
                                        data-name="Path 519"
                                        d="M3.006 1.503a1.5 1.5 0 0 1-1.5 1.5 1.485 1.485 0 0 1-.57-.113 1.5 1.5 0 0 0 0-2.78 1.485 1.485 0 0 1 .57-.113 1.5 1.5 0 0 1 1.5 1.506Z"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <path
                        data-name="Path 520"
                        d="M14.174 15.479V8.936H3.749v9.555h7.413a3.012 3.012 0 0 0 3.012-3.012Z"
                        fill="#cbc5cb"
                    />
                    <path
                        data-name="Path 521"
                        d="M3.749 8.936v1.879h7.571a1.2 1.2 0 0 1 1.2 1.2v3.467a3.012 3.012 0 0 1-3.012 3.012h1.654a3.012 3.012 0 0 0 3.012-3.012V8.939Z"
                        fill="#b5adb6"
                    />
                    <g data-name="Group 166">
                        <path
                            data-name="Path 522"
                            d="M29.179 16.624c-.565-2.29-2.662-3.459-4.939-3.784-.69 1.906-.946 2.889-1.528 4.832h5.635a.851.851 0 0 0 .832-1.048Z"
                            fill="#f2eff2"
                        />
                        <path
                            data-name="Path 523"
                            d="M28.347 17.672h-1.533a.852.852 0 0 0 .832-1.048 4.94 4.94 0 0 0-3.522-3.46l.117-.324c2.277.324 4.374 1.494 4.939 3.784a.852.852 0 0 1-.833 1.048Z"
                            fill="#e1dde1"
                        />
                    </g>
                    <g data-name="Group 167" fill="#12b05e">
                        <path
                            data-name="Path 524"
                            d="M20.349 5.092s1.734 4.735 1.342 8.145a3.342 3.342 0 0 1-3.33 2.941h-6.869v2.09h10.237a1.708 1.708 0 0 0 1.545-.979l2.238-4.747a1.4 1.4 0 0 0 .128-.715l-3.107-7.23Z"
                        />
                        <path
                            data-name="Path 525"
                            d="m25.64 11.827-3.107-7.23-2.184.495s.285.778.6 1.931h.306a1.216 1.216 0 0 1 1.117.736l1.749 4.069a1.4 1.4 0 0 1-.129.715l-2.238 4.747a1.708 1.708 0 0 1-1.545.979h1.52a1.708 1.708 0 0 0 1.544-.979l2.238-4.747a1.4 1.4 0 0 0 .129-.716Z"
                        />
                    </g>
                    <g data-name="Group 169">
                        <path
                            data-name="Path 526"
                            d="M14.174 13.94a.7.7 0 0 1-1.284.375 6.716 6.716 0 0 0-5.629-3.248c-3.416 0-6.254 2.778-6.817 6.431a.856.856 0 0 0 .843.989h9.874a3.012 3.012 0 0 0 3.012-3.012Z"
                            fill="#f2eff2"
                        />
                        <g data-name="Group 168" fill="#e1dde1">
                            <path
                                data-name="Path 527"
                                d="M8.616 11.491v4.615a1.841 1.841 0 0 1-1.841 1.841H3.057a1.841 1.841 0 0 1-1.841-1.841v-1.052a6.839 6.839 0 0 1 6.046-3.986 6.221 6.221 0 0 1 1.274.131.566.566 0 0 1 .08.292Z"
                            />
                            <path
                                data-name="Path 528"
                                d="M14.173 13.94v1.536a3.012 3.012 0 0 1-3.012 3.012h-1.58a3.012 3.012 0 0 0 2.934-3.011v-1.7q.2.258.373.534a.7.7 0 0 0 1.284-.376Z"
                            />
                        </g>
                    </g>
                    <g data-name="Group 170">
                        <path
                            data-name="Path 529"
                            d="M13.241 7.368H3.727a1.565 1.565 0 0 0-1.565 1.565.569.569 0 0 0 .569.569h11.506a.569.569 0 0 0 .569-.569 1.565 1.565 0 0 0-1.565-1.565Z"
                            fill="#685e67"
                        />
                        <path
                            data-name="Path 530"
                            d="M14.806 8.933a.569.569 0 0 1-.569.569H12.71a.569.569 0 0 0 .569-.569 1.564 1.564 0 0 0-1.565-1.565h1.529a1.564 1.564 0 0 1 1.565 1.565Z"
                            fill="#554e55"
                        />
                    </g>
                    <g data-name="Group 171">
                        <path
                            data-name="Path 531"
                            d="M22.767 2.974h-1.822a.569.569 0 0 0-.387.152l-1.7 1.577a.569.569 0 0 0-.182.417v.118a.569.569 0 0 0 .569.569h3.521a1.472 1.472 0 0 0 0-2.833Z"
                            fill="#f2eff2"
                        />
                        <path
                            data-name="Path 532"
                            d="M23.84 4.39a1.281 1.281 0 0 1-1.073 1.416H21.59a1.472 1.472 0 0 0 0-2.833h1.177A1.281 1.281 0 0 1 23.84 4.39Z"
                            fill="#e1dde1"
                        />
                    </g>
                    <path
                        data-name="Path 533"
                        d="M20.915 5.807h-2.34a.674.674 0 0 1 0-1.348h2.34a.569.569 0 0 1 .569.569v.21a.569.569 0 0 1-.569.569Z"
                        fill="#554e55"
                    />
                    <g data-name="Group 174" fill="#12b05e">
                        <g data-name="Group 172">
                            <path
                                data-name="Path 534"
                                d="M7.863 9.962H6.286V7.141a.285.285 0 0 1 .285-.285h1.008a.285.285 0 0 1 .285.285Z"
                            />
                            <path
                                data-name="Path 535"
                                d="M3.545 9.962H1.964V7.141a.285.285 0 0 1 .285-.285h1.015a.285.285 0 0 1 .285.285Z"
                            />
                        </g>
                        <g data-name="Group 173">
                            <path
                                data-name="Path 536"
                                d="M6.774 16.472H3.057a1.841 1.841 0 0 1-1.841-1.841v-4.616a.569.569 0 0 1 .569-.569h6.261a.569.569 0 0 1 .569.569v4.616a1.841 1.841 0 0 1-1.841 1.841Z"
                            />
                            <path
                                data-name="Path 537"
                                d="M8.615 10.015v4.615a1.841 1.841 0 0 1-1.841 1.841H5.249A1.841 1.841 0 0 0 7.09 14.63v-4.615a.569.569 0 0 0-.569-.569h1.524a.569.569 0 0 1 .57.569Z"
                            />
                        </g>
                    </g>
                    <path
                        data-name="Path 538"
                        d="M6.156 13.427h-2.48a.285.285 0 0 1-.285-.285v-1.026a.285.285 0 0 1 .285-.285h2.48a.285.285 0 0 1 .285.285v1.026a.285.285 0 0 1-.285.285Z"
                        fill="#f2eff2"
                    />
                </g>
                <g data-name="Group 179">
                    <g data-name="Group 178">
                        <path
                            data-name="Path 539"
                            d="M8.16 7.366H1.672a.569.569 0 0 1-.569-.569v-5.8a.569.569 0 0 1 .569-.569H8.16a.569.569 0 0 1 .569.569v5.8a.569.569 0 0 1-.569.569Z"
                            fill="#c0694e"
                        />
                        <g data-name="Group 176">
                            <path
                                data-name="Path 540"
                                d="M5.77 3.384V1.419H4.062v1.965a.222.222 0 0 0 .222.222h1.263a.222.222 0 0 0 .223-.222Z"
                                fill="#da875d"
                            />
                            <path
                                data-name="Path 541"
                                d="M5.77 2.399V.434H4.062v1.965a.222.222 0 0 0 .222.222h1.263a.223.223 0 0 0 .223-.222Z"
                                fill="#fddbbf"
                            />
                        </g>
                        <path
                            data-name="Path 542"
                            d="M8.728 1.003v5.8a.569.569 0 0 1-.569.569H6.613a.569.569 0 0 0 .569-.569v-5.8a.569.569 0 0 0-.569-.569h1.546a.569.569 0 0 1 .569.569Z"
                            fill="#c0694e"
                        />
                        <g data-name="Group 177">
                            <path
                                data-name="Path 543"
                                d="M17.923 14.549a.434.434 0 0 0 .434.434h.165a.434.434 0 1 0 0-.868h-.165a.434.434 0 0 0-.434.434Z"
                            />
                            <path
                                data-name="Path 544"
                                d="M29.599 16.521a5.329 5.329 0 0 0-3.722-3.739l.026-.055a1.834 1.834 0 0 0 .168-.937.433.433 0 0 0-.034-.134l-.589-1.37a.435.435 0 1 0-.8.343l.558 1.3a.965.965 0 0 1-.092.429l-2.238 4.747a1.279 1.279 0 0 1-1.152.73h-8.053a3.45 3.45 0 0 0 .743-1.222h3.946a3.771 3.771 0 0 0 3.761-3.326 19.54 19.54 0 0 0-.946-7.045h1.591l1.073 2.5a.435.435 0 0 0 .8-.343l-1.054-2.452a1.983 1.983 0 0 0 .689-1.553 1.708 1.708 0 0 0-1.507-1.851h-1.823a1 1 0 0 0-.683.268L18.95 4.028h-.376a1.108 1.108 0 1 0 0 2.217h1.695a19.607 19.607 0 0 1 .991 6.946 2.858 2.858 0 0 1-.763 1.638V9.943a1 1 0 0 0-1-1H15.24v-.006a2 2 0 0 0-2-2H9.152a1 1 0 0 0 .01-.135v-5.8a1 1 0 0 0-1-1H1.671a1 1 0 0 0-1 1v5.8a1 1 0 0 0 .865.992v1.253a1 1 0 0 0-.752.97v4.614a2.275 2.275 0 0 0 .019.286 8.77 8.77 0 0 0-.788 2.514 1.29 1.29 0 0 0 1.272 1.49h1.6a4.074 4.074 0 0 0 8.1 0h.169a3.429 3.429 0 0 0 1.216-.222h8.975a3.9 3.9 0 1 0 7.715-.815 1.3 1.3 0 0 0 .3-.277 1.265 1.265 0 0 0 .237-1.086ZM20.852 3.445a.135.135 0 0 1 .092-.036h1.822c.34 0 .639.459.639.982s-.3.982-.639.982h-.858a1 1 0 0 0 .01-.135v-.207a1 1 0 0 0-1-1h-.688Zm-2.517 1.686a.24.24 0 0 1 .24-.24h2.34a.135.135 0 0 1 .135.135v.21a.135.135 0 0 1-.135.135h-2.34a.24.24 0 0 1-.24-.24Zm10.422 11.6a.4.4 0 0 1-.076.346.422.422 0 0 1-.334.163h-4.57l1.728-3.665a4.525 4.525 0 0 1 3.252 3.156Zm-2.513 1.94a1 1 0 0 1-1.991 0 .981.981 0 0 1 .176-.564h1.638a.98.98 0 0 1 .177.564Zm-6.616-8.728v5.516a2.939 2.939 0 0 1-1.268.286h-3.761c.007-.088.011-.177.011-.267v-2.48a.434.434 0 0 0-.868 0v.943a.262.262 0 0 1-.483.142 7.371 7.371 0 0 0-4.207-3.2v-.942h4.687v1.012a.434.434 0 0 0 .868 0V9.865a1 1 0 0 0 .121-.058h.957v1.531a.657.657 0 0 0 .657.657h1.263a.657.657 0 0 0 .657-.657v-1.53h1.232a.135.135 0 0 1 .134.135ZM3.111 7.802v1.209h-.712V7.802Zm.868 0h1.872v1.209H3.979Zm2.74 0h.71v1.209H6.72Zm9.834 2.005h.839v1.324h-.839Zm-2.181-.876a.135.135 0 0 1-.135.135s-5.905-.015-5.94-.024v-1.24h4.944a1.132 1.132 0 0 1 1.131 1.129ZM4.499.868h.839v1.319h-.839Zm-2.959.135a.135.135 0 0 1 .135-.135h1.952v1.531a.657.657 0 0 0 .657.657h1.263a.657.657 0 0 0 .657-.657V.868h1.955a.135.135 0 0 1 .135.135v5.8a.135.135 0 0 1-.135.128H1.671a.135.135 0 0 1-.135-.135Zm5.4 20.7a3.2 3.2 0 0 1-3.178-2.776h1.29a1.936 1.936 0 0 0 3.776 0h1.289a3.2 3.2 0 0 1-3.177 2.776Zm-.978-2.776h1.957a1.068 1.068 0 0 1-1.955 0Zm-4.676-.868a.412.412 0 0 1-.317-.146.421.421 0 0 1-.1-.343 8 8 0 0 1 .398-1.539 2.272 2.272 0 0 0 1.79.873h.559a.434.434 0 0 0 0-.868h-.559a1.409 1.409 0 0 1-1.407-1.405v-4.616a.135.135 0 0 1 .135-.135h6.261a.135.135 0 0 1 .135.135v4.616a1.409 1.409 0 0 1-1.407 1.407H5.665a.434.434 0 0 0 0 .868h1.109a2.278 2.278 0 0 0 2.275-2.275v-2.846a6.552 6.552 0 0 1 3.475 2.765 1.131 1.131 0 0 0 1.215.491v.436a2.581 2.581 0 0 1-2.578 2.578Zm23.963 3.64a3.032 3.032 0 0 1-3.029-3.029v-.026a2.159 2.159 0 0 0 .988-.537h.264a1.864 1.864 0 1 0 3.551 0h1.2a3.027 3.027 0 0 1-2.976 3.592Z"
                            />
                            <path
                                data-name="Path 545"
                                d="M6.875 13.143v-1.026a.72.72 0 0 0-.719-.719H3.675a.72.72 0 0 0-.719.719v1.026a.72.72 0 0 0 .719.719h2.48a.72.72 0 0 0 .72-.719Zm-.868-.15H3.825v-.727h2.181Z"
                            />
                            <path
                                data-name="Path 546"
                                d="M5.865 6.044h1.612a.434.434 0 0 0 0-.868H5.865a.434.434 0 0 0 0 .868Z"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
export default SvgCourierAndDistributionsDrivers;
